var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowLeft20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.7069 4.2328a.75.75 0 1 1 1.0862 1.0344L6 9.25h9.75a.75.75 0 0 1 0 1.5H6l3.7931 3.9828a.7499.7499 0 0 1-.0259 1.0603.75.75 0 0 1-1.0603-.0259l-5-5.25a.75.75 0 0 1 0-1.0344l5-5.25Z"
})));
export { SvgArrowLeft20 as ReactComponent };